module.exports = __webpack_public_path__ + "static/media/dashboardv2_um.ec3690dd.png";